document.addEventListener('DOMContentLoaded', () => {
	const fileInput = document.querySelector('#career-file');
	const uploadArea = document.querySelector('.career-form__upload');

	if (!fileInput || !uploadArea) return;

	let fileNameEl = uploadArea.querySelector('.career-form__file-name');

	if (!fileNameEl) {
		fileNameEl = document.createElement('p');
		fileNameEl.className = 'career-form__file-name';
		uploadArea.appendChild(fileNameEl);
	}

	uploadArea.addEventListener('click', (e) => {
		if (e.target === fileInput) return;

		e.preventDefault();
		fileInput.click();
	});

	fileInput.addEventListener('change', () => {
		if (fileInput.files.length > 0) {
			fileNameEl.textContent = fileInput.files[0].name;
		} else {
			fileNameEl.textContent = '';
		}
	});
});
